<template lang="pug">
  v-container(class="pa-15")
    v-row
      v-col(cols="2")
        h2 Lista de tiendas botsol
      v-col.d-flex(cols="4" style=" align-items: baseline;")
        p.pr-2 Filtra por categoria principal
        v-select(v-model="selectedCat" :items="categories" item-text="data" clearable item-value="data" @change="filterShops()"  return-object label="Categoria" solo)
    v-progress-linear(v-if="loading" indeterminate="" color="primary")
    v-data-table.elevation-1(:headers="headers" :search="search" :items="copyShops" :items-per-page="15")
      template(v-slot:top)
        v-text-field.pl-2.pr-2( v-model="search" label="Buscar tienda")
      template(v-slot:item.actions="{ item }")
        v-progress-circular(v-if="item.loading" :size="20" :width="2" color="primary" indeterminate)
        v-btn(v-if="!item.loading" small text :loading="item.loading" color='primary' @click="enabDisabShop(item)")
            | {{item.botsol ? 'Desactivar' : 'Activar' }}
        v-btn(v-if="!item.loading" small text :loading="item.loading" color='primary' @click="deleteShop(item)")
            | Eliminar
</template>

<script>
  import Swal from 'sweetalert2'
  export default {
    components: {
    },
    data () {
      return {
        headers: [
          { text: 'Nombre', value: 'name' },
          { text: 'Telefono', value: 'phone' },
          { text: 'Dirección', value: 'addressgoogle' }, // de notificaciones
          { text: 'Descripción', value: 'description' },
          { text: 'Categoria', value: 'mainCategorie.data' },
          { text: 'Acciones', value: 'actions' },
        ],
        loading: false,
        shops: [],
        copyShops: [],
        search: '',
        categories: [],
        selectedCat: '',
      }
    },
    created () {
      const vm = this
      vm.loading = true
      vm.$store.dispatch('admin/getBotsolShops').then(res => {
        vm.loading = false
        // console.log(res)
        if (res) {
          vm.shops = res
          vm.copyShops = res
        }
      })
      vm.$store.dispatch('shops/getMainCategories', 'en').then((res) => {
        if (res) {
          const categories = res.sort((a, b) => {
            if (a.data > b.data) {
              return 1
            }
            if (a.data < b.data) {
              return -1
            }
            return 0
          })
          vm.categories = categories
        }
      })
    },
    methods: {
      enabDisabShop (item) {
        const vm = this
        vm.loading = true
        vm.$store.dispatch('admin/enabdisabBotsolShop', { data: item }).then((res) => {
          // mostrar swal de exito
          item.botsol = !item.botsol
          vm.loading = false
          Swal.fire({
            icon: 'success',
            title: 'La tienda ha sido ' + (!item.botsol ? 'desactivada' : 'activada'),
            showCancelButton: false,
            confirmButtonColor: '#00CAE3',
            confirmButtonText: 'Ok',
          })
        })
      },
      deleteShop (item) {
        const vm = this
        vm.loading = true
        vm.$store.dispatch('admin/deleteBotsolShop', { data: item }).then((res) => {
          // mostrar swal de exito
          const index = vm.shops.findIndex(el => el.id === item.id)
          if (index) {
            vm.shops.splice(index, 1)
          }
          const index2 = vm.copyShops.findIndex(el => el.id === item.id)
          if (index2) {
            vm.copyShops.splice(index2, 1)
          }
          vm.loading = false
          Swal.fire({
            icon: 'success',
            title: 'La tienda ha sido eliminada',
            showCancelButton: false,
            confirmButtonColor: '#00CAE3',
            confirmButtonText: 'Ok',
          })
        })
      },
      filterShops () {
        const vm = this
        if (vm.selectedCat) {
          vm.copyShops = vm.shops.filter(el => el.mainCategorie.data === vm.selectedCat.data)
        } else {
          vm.copyShops = vm.shops
          vm.selectedCat = ''
        }
      },
    },
  }
</script>
